<template>
  <div id="app" class="min-h-screen">
    <FloatingHearts />
    <router-view />
    <ConfirmDialog />
  </div>
</template>

<script setup lang="ts">
import ConfirmDialog from './components/ConfirmDialog.vue'
import FloatingHearts from './components/FloatingHearts.vue'
</script>
